// Mask secrets before rendering config/metadata anywhere in the UI.
// Tokens must never appear in plaintext (they are persisted in suite meta_data).

type AnyObj = Record<string, any>;

const SECRET_RE = /token|password|secret|access_key|api_key/i;

export const maskToken = (t: string): string =>
  t.length <= 6 ? "••••••" : `${t.slice(0, 4)}••••••${t.slice(-2)}`;

// Strip credentials embedded in a URL: https://user:token@host -> https://user:••••••@host
export const scrubUrlCreds = (s: string): string =>
  typeof s === "string"
    ? s.replace(/(\/\/[^/:@\s]+:)([^@/\s]+)(@)/g, "$1••••••$3")
    : s;

export const maskSecrets = (value: any): any => {
  if (Array.isArray(value)) return value.map(maskSecrets);
  if (value && typeof value === "object") {
    const out: AnyObj = {};
    for (const [k, v] of Object.entries(value)) {
      if (SECRET_RE.test(k) && typeof v === "string" && v.length > 0) {
        out[k] = maskToken(v);
      } else if (typeof v === "string") {
        out[k] = scrubUrlCreds(v);
      } else {
        out[k] = maskSecrets(v);
      }
    }
    return out;
  }
  return typeof value === "string" ? scrubUrlCreds(value) : value;
};
